// Besieg login page decoration (hero + welcome). Runs after DOM is ready
// (the web bundle is included in <head>, before <body> exists).
(function () {
	function run() {
		if (!document.body || document.body.getAttribute('data-path') !== 'login') return;
		document.body.classList.add('besieg-login');
		document.documentElement.classList.add('besieg-login-html');
		var section = document.querySelector('section.for-login');
		if (section && !document.querySelector('.besieg-hero')) {
			var hero = document.createElement('div');
			hero.className = 'besieg-hero';
			hero.innerHTML =
				'<img class="bh-logo" src="/files/besieg_logo_white.png" alt="Besieg Logistics">' +
				'<div class="bh-bar"></div>' +
				'<h1>The future, in motion</h1>' +
				'<p>One platform for every enquiry, shipment and invoice \u2014 moving your business forward, together.</p>';
			section.insertBefore(hero, section.firstChild);
		}
		var card = document.querySelector('.login-content.page-card');
		if (card && !document.querySelector('.bh-welcome')) {
			var w = document.createElement('div');
			w.className = 'bh-welcome';
			w.innerHTML = 'welcome back,<b>to Besieg Logistics</b>';
			card.insertBefore(w, card.firstChild);
		}
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}
})();
